import dayjs, { IST } from '../../lib/dayjsIst';

export function isImage(mimeType) {
  return mimeType && (mimeType.startsWith('image/') || mimeType === 'image/jpg');
}

export function isPdf(mimeType) {
  return mimeType === 'application/pdf';
}

export function attachmentMime(attachment) {
  if (!attachment) return '';
  if (attachment.mimeType) return attachment.mimeType;
  if (attachment.mimetype) return attachment.mimetype;
  return '';
}

export function isLocalFileImage(file) {
  return file && file.type && (file.type.startsWith('image/') || file.type === 'image/jpg');
}

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export function isDocx(mimeType) {
  return mimeType === DOCX_MIME;
}

export function buildFilesQuery(filters) {
  const params = new URLSearchParams();
  if (filters.q && filters.q.trim()) params.set('q', filters.q.trim());
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.report_type && filters.report_type !== 'all') params.set('report_type', filters.report_type);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export function nowIstIso() {
  return `${dayjs().tz(IST).format('YYYY-MM-DDTHH:mm:ss')}+05:30`;
}

export function formatFileDate(val) {
  if (!val) return '';
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return String(val);
  return d.toLocaleString('en-IN', { timeZone: IST });
}

export function formatFileDateTimeParts(val) {
  if (!val) return { date: '', time: '' };
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return { date: String(val), time: '' };
  return {
    date: d.toLocaleDateString('en-IN', { timeZone: IST }),
    time: d.toLocaleTimeString('en-IN', { timeZone: IST, hour: 'numeric', minute: '2-digit' }),
  };
}

export function fileHeadline(file) {
  if (file.report_type && String(file.report_type).trim()) return String(file.report_type).trim();
  if (file.type && String(file.type).trim()) return String(file.type).trim();
  return '';
}

export function countImageAttachments(attachments) {
  if (!Array.isArray(attachments)) return 0;
  let count = 0;
  for (let i = 0; i < attachments.length; i += 1) {
    const a = attachments[i];
    if (a && isImage(attachmentMime(a))) count += 1;
  }
  return count;
}
